import React from 'react'
import { SegmentedToggle } from '../ui'

export function RoleToggle({ role, onRoleChange, isManager = false }) {
  const options = []
  if (isManager) options.push({ value: 'team', label: 'Reports' })
  options.push({ value: 'prep', label: 'My prep' })

  return (
    <div data-testid="role-toggle">
      <SegmentedToggle
        ariaLabel="Switch role view"
        className="segmented--block"
        options={options}
        value={role}
        onChange={onRoleChange}
      />
    </div>
  )
}
